import CategoryList from "@/components/Blog/CategoryList"
import MostReadArticle from "@/components/Blog/MostReadArticle"
import SocialMediaContent from "@/components/Blog/SocialMediaContent"
import Layout from "layout/Layout"
import Head from "next/head"
import Image from "next/image"
import { getArticleDetail, listCategories, listHighlights, listMostReadArticles } from "services/allServices"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { useRouter } from "next/router";
import moment from "moment";
import { useTranslation } from "next-i18next";
import { useEffect, useRef, useState } from "react"
import { successToast } from "@/components/Toast/AllToast";
import copy from 'copy-to-clipboard';
import { useGlobalStore } from "store/GlobalStore"
import Link from "next/link"
import ArticleNewImageModal from "@/components/Blog/ArticleNewImageModal"
import SSSAccordion from "@/components/SSS/SSSAccordion"

const articleDetail = ({ mostReadArticles, allCategories, articleDetail, homeHighlights }) => {
    const defaultNoImage = '/noImageWiki.png';
    const { t } = useTranslation(["blog"]);
    const router = useRouter();
    const [heading, setHeading] = useState([]);
    const [copied, setCopied] = useState(false);
    const [setOtherArticles] = useGlobalStore((state) => [state.setOtherArticles]);

    const languageID = router.locale === "tr" ? 1 : 2;
    const articleData = articleDetail?.article_detail_list?.find((article) => article?.language_id === languageID);
    const articleRef = useRef(null);
    const isFullSlug = articleData?.slug.startsWith('/blog/tr') || articleData?.slug.startsWith('/blog/en');

    const [currentHighlightIndex, setCurrentHighlightIndex] = useState(0);

    const [openImageModal, setOpenImageModal] = useState(false);

    const currentHighlight = homeHighlights[currentHighlightIndex];

    const handleShare = (platform, slug) => {
        const currentUrl = window.location;
        const baseUrl = `${currentUrl.protocol}//${currentUrl.host}`;
        const newUrl = `${baseUrl}/${slug}`;
        if (platform === 'twitter') {
            window.open(`https://twitter.com/intent/tweet?url=${newUrl}`, '_blank');
        } else if (platform === 'facebook') {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${newUrl}`, '_blank');
        } else if (platform === 'whatsapp') {
            window.open(`https://wa.me/?text=${encodeURIComponent(newUrl)}`, '_blank');
        } else if (platform === 'telegram') {
            window.open(`https://t.me/share/url?url=${encodeURIComponent(newUrl)}&text=${encodeURIComponent("Bu içeriğe göz at!")}`, '_blank');
        }
    }

    const handleCopyLink = (slug) => {
        const currentUrl = window.location;
        const baseUrl = `${currentUrl.protocol}//${currentUrl.host}`;
        const newUrl = `${baseUrl}/${slug}`;
        const isCopied = copy(newUrl);

        if (isCopied) {
            setCopied(true);
            successToast("Link kopyalandı!", "Link kopyalandı.");
        }
    };

    useEffect(() => {
        if (articleRef.current) {
            const emptyParagraphs = articleRef.current.querySelectorAll('p:empty');
            emptyParagraphs.forEach((p) => {
                p.style.display = 'block';
                p.style.height = '16px';
                p.style.margin = '8px 0';
            });

            const titleStyle = articleRef.current.querySelectorAll('h3');
            titleStyle.forEach((h3) => {
                h3.style.fontWeight = 'bold';
                h3.style.fontSize = '20px';
            });

            const titleH2Style = articleRef.current.querySelectorAll('h2');
            titleH2Style.forEach((h2) => {
                h2.style.fontWeight = 'bold';
                h2.style.fontSize = '30px';
            })


            const paragraphStyle = articleRef.current.querySelectorAll('p');

            paragraphStyle.forEach((p) => {
                const spanStyle = p.querySelectorAll('span');
                let foundColoredSpan = false;
                let usedBgColor = '';

                spanStyle.forEach((span) => {
                    const bgColor = window.getComputedStyle(span).backgroundColor;
                    if (
                        bgColor !== 'rgb(255, 255, 255)' &&
                        bgColor !== 'rgba(0, 0, 0, 0)' &&
                        bgColor !== 'transparent'
                    ) {
                        foundColoredSpan = true;
                        usedBgColor = bgColor;
                        span.style.color = 'white';
                    }
                });

                if (foundColoredSpan) {
                    const wrapperDiv = document.createElement('div');

                    wrapperDiv.style.width = '100%';
                    wrapperDiv.style.display = 'flex';
                    wrapperDiv.style.flexDirection = 'column';
                    wrapperDiv.style.alignItems = 'center';
                    wrapperDiv.style.justifyContent = 'center';

                    wrapperDiv.style.textAlign = 'center';
                    wrapperDiv.style.paddingTop = '16px';
                    wrapperDiv.style.paddingBottom = '16px';
                    wrapperDiv.style.paddingLeft = '30px';
                    wrapperDiv.style.paddingRight = '30px';
                    wrapperDiv.style.marginBottom = '8px';
                    wrapperDiv.style.backgroundColor = usedBgColor;
                    wrapperDiv.style.color = 'white';
                    wrapperDiv.style.borderRadius = '4px';
                    wrapperDiv.style.lineHeight = '1.4';

                    p.style.margin = '0';
                    p.style.textAlign = 'center';

                    p.parentNode.insertBefore(wrapperDiv, p);
                    wrapperDiv.appendChild(p);
                }
            });

            const liItems = articleRef.current.querySelectorAll('li');

            liItems.forEach((li) => {
                // En yakın UL veya OL öğesini bul
                const list = li.closest('ul, ol');
                if (!list) return;

                const text = li.textContent.trim();

                if (list.tagName === 'UL') {
                    // UL içindeyse, başında ・ yoksa ekle
                    if (!text.startsWith('・')) {
                        li.innerHTML = `<span class="big-bullet">・</span> ${text}`;
                    }
                }
                else if (list.tagName === 'OL') {
                    // OL içindeyse, başında "1. " gibi yoksa index'e göre ekle
                    // parentElement.children OL içindeki tüm LI'ları verir
                    const siblings = Array.from(list.children).filter(el => el.tagName === 'LI');
                    const idx = siblings.indexOf(li);
                    // regex ile zaten “1. “ benzeri varsa tekrar eklemesini engelle
                    if (!/^\d+\.\s+/.test(text) && idx !== -1) {
                        li.innerHTML = `<span class="big-number">${idx + 1}.</span> ${text}`;
                    }
                }
            });

            const linkItems = articleRef.current.querySelectorAll('a');
            linkItems.forEach((a) => {
                a.style.color = '#1d4ed8';
                a.style.textDecoration = 'none';
                a.style.transition = 'all 0.2s ease';
                a.setAttribute('target', '_blank');
                a.setAttribute('rel', 'noopener noreferrer');

                a.addEventListener('mouseenter', () => {
                    a.style.textDecoration = 'underline';
                });
                a.addEventListener('mouseleave', () => {
                    a.style.textDecoration = 'none';
                });
            });

            const contentsHeading = Array.from(titleH2Style).map((title, index) => ({
                id: `heading-${index}`,
                title: title.textContent,
                element: title
            }))

            contentsHeading.forEach((heading) => {
                heading.element.id = heading.id;
            });

            const images = articleRef.current.querySelectorAll('img');
            images.forEach((img) => {
                img.style.cursor = "pointer";
                img.onclick = () => {
                    setOpenImageModal(img.src)
                };
            });

            setHeading(contentsHeading);
        }
    }, [articleData])

    useEffect(() => {
        const otherArticleData = articleDetail.article_detail_list.find((article) => article.language_id !== languageID) ? [articleDetail.article_detail_list.find((article) => article.language_id !== languageID)] : [];
        setOtherArticles(otherArticleData)
    }, [articleDetail])

    useEffect(() => {
        if (homeHighlights?.length > 0) {
            const interval = setInterval(() => {
                setCurrentHighlightIndex((prevIndex) => (prevIndex + 1) % homeHighlights.length);
            }, 60000); // 60 saniye

            return () => clearInterval(interval);
        }
    }, [homeHighlights]);


    return (
        <Layout>
            <Head>
                <title>{articleData?.title}</title>
                <meta name="description" content={articleData?.description} />
                <meta property="og:title" content={articleData?.title} key="title" />
                <meta property="og:description" content={articleData?.description} key="description" />
                <meta property="og:image" content={articleData?.image ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + articleData?.image : "https://makdos.com/headerLogo.png"} />
            </Head>

            <div className="w-full bg-slate-100 lg:bg-white">
                <div className="w-full h-[228px] lg:!h-[264px] items-center justify-center flex bg-makdosYellow "></div>

                <div className="container z-30 mx-auto -mt-40 lg:-mt-72 lg:py-16">
                    {/* İçerik */}
                    <div className="grid lg:gap-6 lg:grid-cols-12">


                        <div className="col-span-1 lg:mx-0 lg:col-span-9">
                            <div className="p-4 bg-white rounded-md lg:p-7">
                                <div className="relative w-full  h-[211px] lg:h-[429px]">
                                    <Image
                                        src={articleData?.image ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + articleData?.image : "/dummyhighlight.svg"}
                                        layout="fill"
                                        alt={articleData?.title}
                                        title={articleData?.title}
                                    />
                                </div>

                                <div>
                                    <h1 className="pt-4 text-4xl font-semibold text-black">{articleData?.title}</h1>
                                </div>

                                <div className="flex flex-col pt-4 lg:space-x-4 lg:items-center lg:flex-row">
                                    <Link
                                        href={isFullSlug ? `${articleData?.category_slug}` : `/blog/${articleData?.category_slug}`}
                                    >
                                        <div className="flex justify-center items-center p-2 space-x-2 text-sm rounded-full cursor-pointer w-fit text-textGray bg-buttonBg">
                                            <div className="w-3 h-3 rounded-full bg-makdosYellow"></div>
                                            <p>
                                                {articleData?.category_title.length > 30 ? articleData?.category_title.substring(0, 30) + "..." : articleData?.category_title}
                                            </p>
                                        </div>
                                    </Link>

                                    <div className="flex items-center space-x-1 font-medium text-slate-400">
                                        <i className="text-base ri-calendar-2-line"></i>
                                        <p className="text-sm">{moment(articleData?.create_time).format("DD.MM.YYYY HH:mm")}</p>
                                    </div>

                                    <div className="flex items-center space-x-1 font-medium text-slate-400">
                                        <i className="text-base ri-user-line"></i>
                                        <p className="text-sm">{articleData?.created_by ? articleData?.created_by : "Makdos"}</p>
                                    </div>

                                    <div className="flex items-center space-x-1 font-medium text-slate-400">
                                        <i className="text-base ri-time-line"></i>
                                        <p className="text-sm">{articleData?.read_time + ' ' + t("blog:minReading")}</p>
                                    </div>
                                </div>

                                <div className="flex justify-between items-center py-6 mt-4 border-y border-buttonBg">
                                    <div className="hidden font-medium text-slate-400 lg:block">{t("blog:shareOnSocialMedia")}</div>
                                    <div>
                                        <div className="space-x-2">
                                            <i className="p-2 text-2xl rounded-full border cursor-pointer border-buttonBg ri-twitter-x-fill" onClick={() => handleShare('twitter', (`blog/${router.locale}/${articleData?.category_slug}/${articleData?.connection_id}/${articleData?.slug}`))}></i>
                                            <i className="p-2 text-2xl rounded-full border cursor-pointer ri-facebook-circle-fill border-buttonBg" onClick={() => handleShare('facebook', (`blog/${router.locale}/${articleData?.category_slug}/${articleData?.connection_id}/${articleData?.slug}`))}></i>
                                            <i className="p-2 text-2xl rounded-full border cursor-pointer border-buttonBg ri-whatsapp-fill" onClick={() => handleShare('whatsapp', (`blog/${router.locale}/${articleData?.category_slug}/${articleData?.connection_id}/${articleData?.slug}`))}></i>
                                            <i className="p-2 text-2xl rounded-full border cursor-pointer border-buttonBg ri-telegram-fill" onClick={() => handleShare('telegram', (`blog/${router.locale}/${articleData?.category_slug}/${articleData?.connection_id}/${articleData?.slug}`))}></i>
                                            <i className="p-2 text-2xl rounded-full border cursor-pointer border-buttonBg ri-share-forward-fill" onClick={() => handleCopyLink(`blog/${router.locale}/${articleData?.category_slug}/${articleData?.connection_id}/${articleData?.slug}`)}></i>
                                        </div>
                                    </div>
                                </div>

                                {articleData?.video_url && <div>
                                    <div className="relative w-full h-[211px] lg:h-[429px]">
                                        <iframe
                                            width="100%"
                                            height="100%"
                                            src={articleData.video_url.replace("watch?v=", "embed/")}
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            className="rounded-md"
                                        ></iframe>
                                    </div>
                                </div>}

                                <div className="pt-4 font-bold text-black">
                                    <p>{articleData?.description}</p>
                                </div>

                                <div className="pt-4 whitespace-pre-wrap article-content" ref={articleRef} dangerouslySetInnerHTML={{ __html: articleData?.message?.replace(/\\n/g, "") }}>

                                </div>

                                {articleData?.similar_articles > 0 &&
                                    <div className="py-8">
                                        <h4 className="pb-2 text-xl font-bold">{t("blog:similarArticles")}</h4>
                                        <div>
                                            {articleData?.similar_articles.map((article, index) => {
                                                return <Link href={article.link} key={index} target="blank">
                                                    <a target="_blank" rel="noopener noreferrer">
                                                        <p className="font-semibold cursor-pointer">{article.title}</p>
                                                    </a>
                                                </Link>
                                            })}
                                        </div>
                                    </div>
                                }


                            </div>
                        </div>

                        <div className="hidden lg:block lg:space-y-6 lg:order-none lg:col-span-3">
                            {/*  Makalenin içindekiler bölümü */}
                            {heading && heading.length > 0 && <div className="p-6 bg-white rounded-lg">
                                <h5 className="flex justify-between text-xl font-semibold">
                                    <span> {t("blog:contents")}</span>
                                </h5>

                                <ul className="mt-4 space-y-2">

                                    {heading.map((head) => (
                                        <li key={head.id} className="py-4 border-b border-buttonBg">
                                            <a href={`#${head.id}`} className="text-textGray" onClick={(e) => {
                                                e.preventDefault();

                                                const element = document.getElementById(head.id);
                                                if (element) {
                                                    const offset = 105;
                                                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                                    const offsetPosition = elementPosition - offset;

                                                    window.scrollTo({
                                                        top: offsetPosition,
                                                        behavior: "smooth"
                                                    });
                                                }
                                            }}>
                                                {head.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>}

                            {currentHighlight && <div className="p-3 bg-white rounded-md cursor-pointer">
                                <Link href={currentHighlight?.content?.link ? currentHighlight?.content?.link : ''} target="_blank">
                                    <div className={`relative`}>

                                        <div className={`absolute z-10 object-cover
                                             ${currentHighlight?.content?.template === 1 ? 'top-52 left-16' : ''}
                                             ${currentHighlight?.content?.template === 2 ? 'top-24 left-16' : ''}
                                            `}>
                                            <Image
                                                src={currentHighlight?.content?.image
                                                    ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + currentHighlight?.content?.image
                                                    : "/defaultHighlight.png"}
                                                width={200}
                                                height={200}
                                                alt={currentHighlight?.content?.image_alt_text ? currentHighlight?.content?.image_alt_text : ""}
                                                title={currentHighlight?.content?.image_title ? currentHighlight?.content?.image_title : ""}
                                                onError={({ currentTarget }) => {
                                                    currentTarget.onerror = null;
                                                    currentTarget.src = defaultNoImage
                                                    currentTarget.srcset = defaultNoImage
                                                }}
                                            />
                                        </div>
                                        <h4 className={`absolute font-bold z-10 text-sm px-4 py-2 text-center grid place-items-center w-full h-[20px]
                                             ${currentHighlight?.content?.template === 2 ? 'bottom-40' : ''}
                                            `}>{currentHighlight?.content?.image_title}</h4>
                                        <p className={`absolute z-10 text-[8px] px-4 py-4 text-center grid place-items-center w-full h-[20px]
                                            ${currentHighlight?.content?.template === 1 ? 'top-10' : ''}
                                            ${currentHighlight?.content?.template === 2 ? 'bottom-28' : ''}
                                            `}>{currentHighlight?.content?.image_alt_text}
                                        </p>
                                        <p className={`absolute z-10 font-bold text-xs text-white grid place-items-center text-center w-full h-[20px]
                                            ${currentHighlight?.content?.template === 1 ? 'top-[119px]' : ''}
                                             ${currentHighlight?.content?.template === 2 ? 'bottom-10' : ''}
                                            `}>
                                            {currentHighlight?.content?.button_text}
                                        </p>
                                        <Image
                                            src={currentHighlight?.content?.template_path
                                                ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + currentHighlight?.content?.template_path
                                                : "/defaultHighlight.png"}
                                            width={400}
                                            height={718}
                                            alt={currentHighlight?.content?.image_alt_text ? currentHighlight?.content?.image_alt_text : ""}
                                            title={currentHighlight?.content?.image_title ? currentHighlight?.content?.image_title : ""}
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = defaultNoImage
                                                currentTarget.srcset = defaultNoImage
                                            }}
                                        />
                                    </div>
                                </Link>
                                {/* <Link href={currentHighlight?.link ? currentHighlight?.link : "https://makdos.com/tr/sunucular/sanal-sunucular/"} target="_blank">
                                    <Image
                                        src={currentHighlight?.image
                                            ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + currentHighlight?.image
                                            : "/defaultHighlight.png"}
                                        width={398}
                                        height={518}
                                        alt={currentHighlight?.image_alt_text ? currentHighlight?.image_alt_text : "Sanal Sunucu Hizmetleri"}
                                        title={currentHighlight?.image_title ? currentHighlight?.image_title : "Sanal Sunucu Hizmetleri"}
                                    />
                                </Link> */}





                            </div>}

                            <div className="p-4 bg-white rounded-md">
                                <MostReadArticle mostReadArticles={mostReadArticles} />
                            </div>

                            <CategoryList allCategories={allCategories} />
                            <SocialMediaContent />
                        </div>
                    </div>
                </div>
            </div>
            {openImageModal &&
                <ArticleNewImageModal
                    isOpen={openImageModal}
                    onClose={() => setOpenImageModal(false)}
                    imageSrc={openImageModal}
                />
            }

            {
                articleData?.faq?.length > 0 &&

                <section className="container px-4 mx-auto bg-white lg:px-0">
                    <div className="">
                        <span className="relative z-30 text-4xl font-semibold text-after-shadow lg:text-5xl">{t('common:frequentlyAskedQuestions')}</span>
                        <div className="grid grid-cols-2 mt-10 lg:gap-x-8">
                            {articleData?.faq.map((faq, index) => {
                                return (
                                    <SSSAccordion key={index} title={faq.question}>
                                        <div dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
                                    </SSSAccordion>
                                )
                            })
                            }
                        </div>
                    </div>

                </section>
            }

        </Layout >
    )
}

export default articleDetail

export const getServerSideProps = async ({ locale, params, query }) => {
    let localeData = locale === "tr" ? 1 : 2;

    let mostReadArticles = {};
    await listMostReadArticles(localeData).then((res) => {
        mostReadArticles = res;
    })

    let allCategories = {};
    await listCategories(localeData).then((res) => {
        allCategories = res;
    })

    let articleDetail = {};
    await getArticleDetail(query.connection_id, localeData).then((res) => {
        if (res?.status !== 'article_not_found') {
            articleDetail = res;
        }
    })

    if (!articleDetail?.article_detail_list || articleDetail.article_detail_list.length === 0) {
        return {
            notFound: true,
        };
    }

    let highlightsData = {};
    await listHighlights(query.connection_id, localeData).then((res) => {
        highlightsData = res;
    })

    let homeHighlights = {};
    await listHighlights(Number(params?.connection_id), localeData, "article").then((res) => {
        homeHighlights = res;
    })

    return {
        props: {
            ...await serverSideTranslations(locale, ["common", "nav", "blog"]),
            mostReadArticles: mostReadArticles,
            allCategories: allCategories,
            articleDetail: articleDetail,
            highlightsData: highlightsData,
            homeHighlights: homeHighlights,
        }
    };
};